//import 
//<script src="https://js.stripe.com/v3/"></script>
//
//
// Card numbers && tokens for testing : https://stripe.com/docs/testing

//TO DO : 
//- In your checkout or manageCard page, call the com : 
//		stripe = Fw.component.models().stripeToken;	  
//	  stripe.init();
//- Edit your form style below (style var) : https://stripe.com/docs/stripe-js/reference#element-options
//- Create a <div> with an id corresponding to var ccFieldsId (line 29) (your fields (CCNumber, exp, cvv) will automatically appear here)
//- Make sure you have a container with id : var cardErrorsId (line 28). In case of an error in the CC, the message will appear here. You can customize the messages. (replace event.error.message and result.error.message with your own messsage)
//- Specify the button class on which you want the listener to be (to generate de token) : var button = $('.membership-payment-submit-btn'); line 27
// - Get the token : result.token.id and send it to the BE (param : cardToken) in the final step of the payment OR in the manageCard action (save card)
//
//- Once LIVE : Get the PUBLIC API KEY from the client and replace [YOUR PUBLIC API KEY] with it.

(function($, undefined) {
	
	'use strict';
	
	var APIK_TEST = 'pk_test_HhX3YNMlO2VMhFdx6AFnBe3q';
	var APIK_LIVE = 'pk_live_08KZKWGnxV1jteoU25abL1bH';

	var validateForm = function (t) {
		if (typeof Stripe !== "function") return;
		
		// Create a Stripe client.
		var stripe = Stripe(($("html").attr("data-is-dev") === 'true' || $("html").attr("data-is-staging") === 'true') ? APIK_TEST : APIK_LIVE);

		var ccFields = t;
		var form = ccFields.closest('form');
		var button = $('.get-stripe-token', form);
		var ccFieldsId = ccFields.attr('id');
		var cardErrors = $('.card-errors', form);
		
		if ($('#'+ ccFieldsId).length !== 0) {
			// Create an instance of Elements.
			var elements = stripe.elements();

			// Custom styling can be passed to options when creating an Element.
			var style = {
				base: {
					color: '#212121',
					lineHeight: '22px',
					fontFamily: 'Lato, "Helvetica Neue", Helvetica, sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '16px',
					'::placeholder': {
						color: '#c5c5c5'
					}
				},
				invalid: {
					color: '#e73024',
					iconColor: '#e73024'
				}
			};

			//// Create an instance of the card Element. Remove hidePostalCode if PC validation required
			var card = elements.create('card', {
				hidePostalCode: true, style: style});

			card.mount('#' + ccFieldsId);

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function (event) {
				if (event.error) {
					cardErrors.html(event.error.message);
				} else {
					cardErrors.html('');
				}
			});

			// Handle form submission.
			button.on('click', function (event) {
				event.preventDefault();

				stripe.createToken(card).then(function (result) {
					if (result.error) {
						// Inform the user if there was an error.
						cardErrors.html(result.error.message);
					} else {
						var m;
						if (result.token.card.exp_month < 10) {
							m = '0' + result.token.card.exp_month;
						} else {
							m = result.token.card.exp_month;
						}

						// Send the token in a stripeToken param in the payment
						$('input[name=cardToken]', form).val(result.token.id);
						// Send cc inputs to backend
						$('input[type=hidden].ccType', form).val(result.token.card.brand);
						$('input[type=hidden].cc', form).val(result.token.card.last4);
						$('input[type=hidden].mm', form).val(m);
						$('input[type=hidden].yy', form).val(result.token.card.exp_year.toString().substring(2));
					}
                    // In subscription checkout the validation will go through recaptcha next so no submission after
                    if (form.find('.recaptcha-ctn').length === 0) {
                        form.trigger('submit');
                    } else if (!!grecaptcha) {
                        grecaptcha.execute(button.attr('data-widget-id'));
                    }
				});
			});
		}
	};

	Fw.component.export('stripeToken', {
		init: validateForm
	});

})(jQuery);